import { getAsyncInjectors } from '../../../utils/asyncInjectors'
import { useAuthStore } from '../../../zustand/authentication/use-auth-store'

export async function initializeApp(store) {
  const { initializedApp, setInitializedApp } = useAuthStore.getState()

  if (initializedApp) return

  try {
    const [reducersModule, sagasModule] = await Promise.all([
      import('../../../reducers'), // Assuming reducers are exported from this module
      import('../../../sagas') // Assuming sagas are exported from this module
    ])

    const { injectReducers, injectSagas } = getAsyncInjectors(store)
    injectReducers(Object.entries(reducersModule))

    for (const saga of Object.values(sagasModule)) {
      injectSagas(saga)
    }

    setInitializedApp(true)
  } catch (err) {
    setInitializedApp(false)
    throw err
  }
}
